import { useSliderLayout } from '../hooks/useSliderLayout';

const SliderTrack = ({ children, centerMode }: any) => {
	const { blockClass } = useSliderLayout();

	return (
		<div
			className={`sliderTrack sliderTrack--${blockClass} vtex-slider-layout-0-x-sliderTrack vtex-slider-layout-0-x-sliderTrack--${blockClass} flex ${centerMode !== 'disabled' ? '' : 'justify-around'} relative pa0 ma0`}
			aria-live="polite"
			style={{
				width: '100%',
			}}
		>
			{children}
		</div>
	);
};

export default SliderTrack;
